// LGX-653: generic saved-filter API client. `pageKey` scopes everything to one grid (e.g.
// "orders"); the same client works for any future grid that adopts this feature.
import axios from "axios";
import Cookies from "js-cookie";

const API_ROOT = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

const withAuthHeaders = () => {
  const token = Cookies.get("authToken");
  // Singular, current-acting office -- matches the backend's single-office-code column and its
  // org-tree comparison (OrganizationService.isOfficeInSameOrgTree expects one code, not a list).
  const officeCode = Cookies.get("officeCode");

  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(officeCode ? { "Office-Code": officeCode } : {}),
  };
};

export const savedFiltersApi = {
  list: (pageKey) =>
    axios.get(`${API_ROOT}/api/saved-filters`, {
      params: { pageKey },
      headers: withAuthHeaders(),
    }),

  create: (body) =>
    axios.post(`${API_ROOT}/api/saved-filters`, body, {
      headers: { "Content-Type": "application/json", ...withAuthHeaders() },
    }),

  remove: (id) =>
    axios.delete(`${API_ROOT}/api/saved-filters/${id}`, {
      headers: withAuthHeaders(),
    }),
};
